import { makeStyles } from "@fluentui/react-components";
import { themeTokens } from "Core/Theme/M365PulseTheme.types";

export const useStyles = makeStyles({
    root: {
        width: "48px",
        color: themeTokens.colorNeutralForegroundOnBrand,
        height: "48px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ":hover": {
            cursor: "pointer",
            backgroundColor: themeTokens.menuHoverBackgroundColor
        }
    },
    hiddenStyle: {
        display: "none"
    }
});
